import React, { useEffect, useState } from 'react';
import { XIcon, SendIcon } from 'lucide-react';
export const WhatsAppButton = () => {
  const [showMessage, setShowMessage] = useState(false);
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    // Show the message bubble after 10 seconds
    const timer = setTimeout(() => {
      setShowMessage(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowMessage(false);
  };
  const handleButtonClick = () => {
    if (!expanded) {
      setExpanded(true);
    } else {
      // Keep expanded state, will be handled by the button inside
    }
  };
  const openWhatsApp = () => {
    window.open('https://wa.me/31612345678?text=Hallo%2C%20ik%20heb%20een%20vraag%20over%20bootstoffering.', '_blank', 'noopener,noreferrer');
  };
  return <div className="fixed bottom-6 right-6 z-50 flex items-end" data-id="element-179">
      {/* WhatsApp notification bubble */}
      {showMessage && !expanded && <div className="bg-white rounded-2xl shadow-lg py-3 px-4 mr-3 mb-2 relative animate-fade-in max-w-[260px]" data-id="element-180">
          <button onClick={handleClose} className="absolute -top-1 -right-1 bg-white rounded-full p-1 shadow-sm" aria-label="Sluiten" data-id="element-181">
            <XIcon className="w-3 h-3 text-gray-500" data-id="element-182" />
          </button>
          <p className="text-sm text-gray-700 font-medium" data-id="element-183">
            Nieuw bericht van WhatsApp
          </p>
          <p className="text-xs text-gray-600 mt-1" data-id="element-184">
            Heeft u vragen over bootstoffering? Ik help u graag!
          </p>
        </div>}
      {/* WhatsApp button */}
      <div onClick={handleButtonClick} className="cursor-pointer" data-id="element-185">
        {expanded ? <div className="bg-white rounded-lg shadow-lg p-0 mb-2 animate-fade-in overflow-hidden" data-id="element-186">
            <div className="flex flex-col w-72" data-id="element-187">
              {/* WhatsApp header with brand colors */}
              <div className="bg-[#075e54] text-white p-3 flex items-center" data-id="element-188">
                <div className="mr-2" data-id="element-189">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q4Fkq9h3Zd6cy57UUc3QNc/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="WhatsApp" className="w-6 h-6" data-id="element-190" />
                </div>
                <h3 className="text-lg font-medium" data-id="element-191">WhatsApp</h3>
              </div>
              {/* Chat profile header - improved profile picture containment */}
              <div className="flex items-center px-4 py-3 border-b border-gray-100" data-id="element-192">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-3 bg-white flex items-center justify-center shadow-sm" data-id="element-193">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4cQxLExUfJcgB5MdwAc9mb/foto.png" alt="Marco Leer" className="w-full h-full object-cover object-center" data-id="element-194" />
                </div>
                <div data-id="element-195">
                  <h3 className="text-gray-800 font-medium" data-id="element-196">Marco Leer</h3>
                  <p className="text-xs text-green-600 flex items-center" data-id="element-197">
                    <span className="inline-block w-2 h-2 bg-green-500 rounded-full mr-1" data-id="element-198"></span>
                    Online • Meestal binnen 60 min.
                  </p>
                </div>
              </div>
              {/* Chat messages */}
              <div className="bg-[#e5ddd5] p-3 min-h-[120px] space-y-2" data-id="element-199">
                <div className="flex justify-start" data-id="element-200">
                  <div className="bg-white text-gray-800 rounded-lg p-2 max-w-[80%] shadow-sm relative chat-bubble-left" data-id="element-201">
                    <p className="text-sm" data-id="element-202">
                      Welkom bij Marco Leer Bootstoffering! Heeft u vragen over
                      uw bootstoffering project? Ik help u graag verder.
                    </p>
                    <span className="text-[10px] text-gray-500 block text-right mt-1" data-id="element-203">
                      Nu
                    </span>
                  </div>
                </div>
              </div>
              {/* Call-to-action - redesigned to be more professional and compact */}
              <div className="bg-[#f0f0f0] p-4" data-id="element-204">
                <p className="text-sm text-gray-700 mb-3" data-id="element-205">
                  Stel uw vraag direct via WhatsApp en ontvang snel antwoord van
                  ons team.
                </p>
                <div className="flex justify-between items-center" data-id="element-206">
                  <button onClick={openWhatsApp} className="bg-[#25d366] hover:bg-[#1ea952] text-white font-medium rounded-md py-2 px-4 flex items-center justify-center transition-colors text-sm" data-id="element-207">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q4Fkq9h3Zd6cy57UUc3QNc/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="" className="w-4 h-4 mr-2" data-id="element-208" />
                    WhatsApp Gesprek
                  </button>
                  <button onClick={() => setExpanded(false)} className="text-gray-500 hover:text-gray-700 text-sm px-3 py-2" data-id="element-209">
                    Sluiten
                  </button>
                </div>
              </div>
            </div>
          </div> : <div className="bg-[#25d366] text-white rounded-full p-3 shadow-lg hover:bg-[#1ea952] transition-colors relative" data-id="element-210">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q4Fkq9h3Zd6cy57UUc3QNc/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="WhatsApp" className="w-7 h-7" data-id="element-211" />
            {/* Added notification dot when message is available but not shown */}
            {showMessage && <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white" data-id="element-212"></span>}
          </div>}
      </div>
      <style jsx data-id="element-213">{`
        .chat-bubble-left:after {
          content: '';
          position: absolute;
          left: -8px;
          top: 0;
          border: 8px solid transparent;
          border-top-color: white;
          border-left: 0;
          border-top-left-radius: 0;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fadeIn 0.3s ease forwards;
        }
      `}</style>
    </div>;
};